// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WAFqL","content":"styles_content__xz4KQ","tableWrap":"styles_tableWrap__268oQ"};